import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import Spinner from '../../../../common/spinner/Spinner.jsx';
import { MainTitle } from '../../../../common/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useGetNonArchivedEventsQuery } from '../../../../../redux/services/fo_events.jsx';
import EventsTable from '../../../../common/FriOpen/Events/EventsTable/EventsTable.jsx';

const EventsPublicPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data: events,
    isLoading: isLoadingEvents,
    refetch: refetchEvents,
  } = useGetNonArchivedEventsQuery(false);

  return (
    <>
      <MainTitle title={t('FRI akcie')} />


      <CollapseBlock title={t('Zoznam aktuálnych FRI akcií')}>
        {isLoadingEvents ? (
          <Spinner />
        ) : (
          <EventsTable
            events={events}
            refetch={refetchEvents}
            onDetailClick={(event) =>
              navigate(routes.friOpenEventsDetail(event.id))
            }
            onRowClick={(event) =>
              navigate(routes.friOpenEventsDetail(event.id))
            }
            onDelete={undefined}
          />
        )}
      </CollapseBlock>
    </>
  );
};

export default EventsPublicPage;
